import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferralComponent } from './referral.component';
import { ReferralRoutingModule } from './referral.routing.module';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';
import { RequestReferralComponent } from './request-referral/request-referral.component';
import { SpecifyPreferencesComponent } from './request-referral/specify-preferences/specify-preferences.component';
import { AddDetailsComponent } from './request-referral/add-details/add-details.component';
import { SelectSpecialityComponent } from './request-referral/select-speciality/select-speciality.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SummaryComponent } from './generic-components-referral/summary/summary.component';
import { MyReferralRequestsComponent } from './generic-components-referral/my-referral-requests/my-referral-requests.component';
import { ReferralReadyComponent } from './generic-components-referral/referral-ready/referral-ready.component';
import { PendingAppointmentRequestsComponent } from './generic-components-referral/pending-appointment-requests/pending-appointment-requests.component';
import { ConfirmedAppointmentsComponent } from './generic-components-referral/confirmed-appointments/confirmed-appointments.component';
import { MemberEligibilityComponent } from './member-eligibility/member-eligibility.component';
import { AddLocationComponent } from './request-referral/add-location/add-location.component';
import { InsuranceFilterPipe } from '../shared/pipes/insurance-filter.pipe';
import { RemoveLocationComponent } from './request-referral/remove-location/remove-location.component';
import { AddAddressService } from '../../services/scheduling/add-address/add-address.service';
import { AppointmentsService } from '../../services/scheduling/appointment/appointments.service';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
	imports: [
		CommonModule,
		ReferralRoutingModule,
		SharedModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		MatChipsModule,
	],
	declarations: [
		ReferralComponent,
		RequestReferralComponent,
		SpecifyPreferencesComponent,
		AddDetailsComponent,
		SelectSpecialityComponent,
		ConfirmedAppointmentsComponent,
		SummaryComponent,
		MyReferralRequestsComponent,
		ReferralReadyComponent,
		PendingAppointmentRequestsComponent,
		MemberEligibilityComponent,
		AddLocationComponent,
		InsuranceFilterPipe,
		RemoveLocationComponent,
	],
	providers: [
		{ provide: AddAddressService, useClass: AddAddressService },
		{ provide: AppointmentsService, useClass: AppointmentsService },
	],
})
export class ReferralModule {}
